import type { DevEnv } from "../../../../types/environment.ts";
import type { AwsPartition } from "../util.ts";
import type { AwsPolicyOptions } from "./policies.ts";
import { roleInstallCommands, roleTerraform } from "./shared.ts";

export const inventoryInstallCommands = (
  context: DevEnv,
  options: AwsPolicyOptions,
  args: {
    gcloudServiceAccountId: string;
    awsAccountId: string;
    awsPartition: AwsPartition;
  }
) => roleInstallCommands("inventory", context, options, args);

export const inventoryTerraform = (
  context: DevEnv,
  options: AwsPolicyOptions,
  gcloudServiceAccountId: string,
  awsPartition: AwsPartition
) =>
  roleTerraform(
    "inventory",
    context,
    options,
    gcloudServiceAccountId,
    awsPartition
  );
